"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const useSize_1 = __importDefault(require("../../utils/useSize"));
const search_result_container_1 = __importDefault(require("./search-result-container"));
const utils_1 = require("../../utils/utils");
// export default
function ListView({ getSearchResultComponent, searchResults, currentLocation, mapResultsScroll, resultsScroll, showMap, mapRef, hovered, setHovered, selected, setSelected, focusOnLocation, searchResultRefs, hasApplicationHeader, searchResultsHeader }) {
    const { sizeWidth } = (0, useSize_1.default)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const getSearchResults = (0, react_1.useCallback)(() => {
        return (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "results", ref: resultsScroll }, { children: [searchResultsHeader && searchResultsHeader, searchResults.map((m, i) => ((0, jsx_runtime_1.jsx)(search_result_container_1.default, { searchResultComponent: getSearchResultComponent(m), showTopBorder: i !== 0 || !!searchResultsHeader, location: m, hoverHighlight: (sizeWidth > 767 || showMap) && (hovered === null || hovered === void 0 ? void 0 : hovered.id) === m.id, selectedHighlight: (sizeWidth > 767 || showMap) && (selected === null || selected === void 0 ? void 0 : selected.id) === m.id, onClick: () => {
                        setSelected(m);
                        focusOnLocation(m);
                        (0, utils_1.setBoundsToInclude)(m, mapRef, currentLocation, false);
                    }, onKeyDown: (e) => {
                        if (e.key === "Enter") {
                            setSelected(m);
                            focusOnLocation(m);
                            (0, utils_1.setBoundsToInclude)(m, mapRef, currentLocation, false);
                        }
                    }, onMouseEnter: () => {
                        setHovered(m);
                    }, onMouseLeave: () => {
                        setHovered(null);
                    }, ref: (ref) => {
                        var _a;
                        (_a = searchResultRefs.current) === null || _a === void 0 ? void 0 : _a.set(m.id, ref);
                    } }, m.id)))] }));
    }, [searchResults, hovered, selected]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "map-results-scroll", ref: mapResultsScroll, style: { height: `calc(100% - ${hasApplicationHeader ? 9 : 5}rem)` } }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "ontario-show-for-sr" }, { children: t('searchResultsHeading') })), getSearchResults()] })));
}
exports.default = ListView;
